import "./Benefits.css";


import Navbar from "../../component/Navbar/Navbar";
import Footer from "../../component/Footer/Footer";

import {
  FaIdCard,
  FaShieldAlt,
  FaHeadset,
  FaFileInvoice,
} from "react-icons/fa";

function Benefits() {
  const benefits = [
    {
      icon: <FaIdCard />,
      title: "Digital Membership ID",
      text: "Get your membership identification digitally.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Family Protection",
      text: "Support and protection benefits for your family.",
    },
    {
      icon: <FaHeadset />,
      title: "Claim Assistance",
      text: "Get assistance throughout the claim process.",
    },
    {
      icon: <FaFileInvoice />,
      title: "Online Receipts",
      text: "Access your payment receipts online.",
    },
  ];

  return (
    <>
     

      <Navbar />

      <main className="benefits-page">

        <div className="benefits-container">

          <h1>
            Membership Benefits
          </h1>

          <p>
            Benefits available to APNB members.
          </p>


          <div className="benefits-grid">

            {benefits.map((item) => (

              <div
                className="benefit-card"
                key={item.title}
              >

                <div className="benefit-icon">
                  {item.icon}
                </div>

                <h2>
                  {item.title}
                </h2>

                <p>
                  {item.text}
                </p>

              </div>

            ))}

          </div>

        </div>

      </main>

      <Footer />
    </>
  );
}

export default Benefits;